import * as layout from '../../../../components/markLayout.module.css';
import { MarkInput, MarkLabel } from '../../../../components/MarkControls';
import React, { useId } from 'react';
import RefPicker from '../RefPicker';
import ExitReasonSelect from '../ExitReasonSelect';
import { DEFAULT_AB_SPLIT_RATIO } from '../../../../constants';
import type { AbSplitStep, DripStep, AuthorableDripExitReason } from '../../../../types';
type Props = {
    step: AbSplitStep;
    allSteps: DripStep[];
    onChange: (patch: Partial<AbSplitStep>) => void;
};
const AbSplitForm: React.FC<Props> = ({ step, allSteps, onChange }) => {
    const ratioId = useId();
    const ratio = step.ratio ?? DEFAULT_AB_SPLIT_RATIO;
    const showExitReason = step.arms.A === 'exit' || step.arms.B === 'exit';
    return (
        <div className={layout.form}>
            <div className={layout.field}>
                <MarkLabel
                    htmlFor={ratioId}
                    style={{
                        display: 'block',
                        marginBottom: '0.4rem'
                    }}
                >
                    Ratio (arm A %)
                </MarkLabel>
                <MarkInput
                    id={ratioId}
                    type="number"
                    min={0}
                    max={100}
                    value={ratio}
                    onChange={(e) => {
                        const v = Math.min(
                            100,
                            Math.max(0, Math.floor(Number(e.currentTarget.value) || 0))
                        );
                        onChange({ ratio: v });
                    }}
                    style={{
                        textAlign: 'center'
                    }}
                />
                <span
                    style={{
                        color: 'var(--mark-muted)',
                        marginLeft: '0.8rem'
                    }}
                >
                    arm A: {ratio}% / arm B: {100 - ratio}%
                </span>
            </div>
            <RefPicker
                label="Arm A"
                value={step.arms.A}
                onChange={(v) => onChange({ arms: { ...step.arms, A: v } })}
                steps={allSteps}
                currentStepId={step.id}
            />
            <RefPicker
                label="Arm B"
                value={step.arms.B}
                onChange={(v) => onChange({ arms: { ...step.arms, B: v } })}
                steps={allSteps}
                currentStepId={step.id}
            />
            {showExitReason && (
                <ExitReasonSelect
                    value={step.exit_reason as AuthorableDripExitReason | undefined}
                    onChange={(v) => onChange({ exit_reason: v })}
                />
            )}
        </div>
    );
};
export default AbSplitForm;
